/**
 * BDY-CTRL: Product card interactions
 *
 * 1. HOVER IMAGE REVEAL — image area only
 *    Adds/removes .card--img-hovered on the card wrapper when the cursor
 *    enters/leaves the .card__inner image box. CSS uses that class to reveal
 *    the secondary image — scoped to the photo, not the whole card.
 *
 * 2. COLOUR SWATCH CLICK → card image swap
 *    Swaps the primary image to the clicked colour's variant image,
 *    updates card links to the variant URL, toggles the active swatch.
 *    Image data uses a 3-level fallback in Liquid so the attribute is
 *    always present: variant image → variant_ids scan → product primary image.
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────────────────────
     1. HOVER IMAGE — add / remove .card--img-hovered
     Uses mouseover/mouseout with bubble detection so it works on
     dynamically rendered cards (sliders, infinite scroll, etc.)
     ───────────────────────────────────────────────────────────── */

  document.addEventListener('mouseover', function (e) {
    var inner = e.target.closest('.card__inner');
    if (!inner) return;
    var wrapper = inner.closest('.card-wrapper');
    if (wrapper) wrapper.classList.add('card--img-hovered');
  });

  document.addEventListener('mouseout', function (e) {
    var inner = e.target.closest('.card__inner');
    if (!inner) return;
    var wrapper = inner.closest('.card-wrapper');
    if (!wrapper) return;
    /* Only remove when the cursor truly leaves card__inner, not just
       moves between child elements inside it */
    if (!inner.contains(e.relatedTarget)) {
      wrapper.classList.remove('card--img-hovered');
    }
  });

  /* ─────────────────────────────────────────────────────────────
     2. COLOUR SWATCH CLICK → swap card image
     ───────────────────────────────────────────────────────────── */

  function swapCardImage(swatch) {
    var wrapper = swatch.closest('.card-wrapper');
    if (!wrapper) return;

    /* Swap primary image */
    var src    = swatch.dataset.variantMediaSrc;
    var srcset = swatch.dataset.variantMediaSrcset;
    var alt    = swatch.dataset.variantMediaAlt;

    if (src) {
      var primaryImg = wrapper.querySelector('[data-card-primary-image]');
      if (primaryImg) {
        primaryImg.src = src;
        if (srcset) primaryImg.srcset = srcset;
        if (alt)    primaryImg.alt    = alt;
      }
    }

    /* Swap hover image if variant-specific hover data is provided */
    var hoverSrc    = swatch.dataset.variantHoverSrc;
    var hoverSrcset = swatch.dataset.variantHoverSrcset;
    if (hoverSrc) {
      var hoverImg = wrapper.querySelector('[data-card-hover-image]');
      if (hoverImg) {
        hoverImg.src = hoverSrc;
        if (hoverSrcset) hoverImg.srcset = hoverSrcset;
      }
    }

    /* Update card title / image links to point to this variant */
    var href = swatch.getAttribute('href');
    if (href) {
      wrapper.querySelectorAll('a.full-unstyled-link').forEach(function (link) {
        link.href = href;
      });
    }

    /* Toggle active swatch highlight */
    wrapper.querySelectorAll('.card__color-swatch').forEach(function (s) {
      s.classList.remove('card__color-swatch--active');
    });
    swatch.classList.add('card__color-swatch--active');
  }

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.card__color-swatch');
    if (!swatch) return;
    e.preventDefault();
    swapCardImage(swatch);
  });

})();
// Make entire product card clickable
document.addEventListener('click', function (e) {
  const wrapper = e.target.closest('.card-wrapper');
  if (!wrapper) return;

  // Ignore clicks on interactive elements
  if (e.target.closest('a, button, input, select, textarea, [role="button"]')) return;

  // Find the primary card link and navigate to it
  const link = wrapper.querySelector('[id^="CardLink-"]');
  if (!link) return;

  // Respect modifier keys for open-in-new-tab etc.
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
    window.open(link.href, '_blank');
  } else {
    window.location.href = link.href;
  }
});

// Show pointer cursor over the card (excluding interactive elements)
document.addEventListener('mouseover', function (e) {
  const wrapper = e.target.closest('.card-wrapper');
  if (!wrapper) return;
  if (e.target.closest('a, button, input, select, textarea, [role="button"]')) return;
  wrapper.style.cursor = 'pointer';
});